const Spinner = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'w-4 h-4 border-2',
    md: 'w-7 h-7 border-[2.5px]',
    lg: 'w-10 h-10 border-3',
    xl: 'w-14 h-14 border-[3px]'
  };

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div
        className={`${sizeClasses[size]} border-neutral-200 border-t-primary-600 rounded-full animate-spin`}
      />
    </div>
  );
};

export default Spinner;
